import { action } from 'typesafe-actions'
import { IAxiosResponse, IPaginator, ISearch } from '../root.types'
import { UserTypes } from './types'
import { TypesUser } from '../../application/models/user/user'

/* Action resetar state */
export const resetCreate = () => action(UserTypes.RESET_CREATE)
export const resetPaginator = () => action(UserTypes.RESET_PAGINATOR)

/* Action procurar por busca*/
export const changeSearch = (search: ISearch) => action(UserTypes.CHANGE_SEARCH, { search })

/* Actions cria user */
export const createUserRequest = (user: any, avatar?: any) => action(UserTypes.CREATE_USER_REQUEST, { user, avatar })

export const createUserSuccess = (user: any) => [action(UserTypes.CREATE_USER_SUCCESS, { user }), resetCreate()]

export const createUserFailure = (e: any) => action(UserTypes.CREATE_USER_FAILURE, { e })

/* Actions para carregar todos usuarios */
export const loadUsers = (typeUser:TypesUser,paginator: IPaginator) =>action(UserTypes.LOAD_USER_REQUEST, { typeUser,paginator })

export const loadUserSuccess = (response: IAxiosResponse<any[]>) => action(UserTypes.LOAD_USER_SUCCESS, response)

export const loadUserFailure = () => action(UserTypes.LOAD_USER_FAILURE)

/* Actions para buscar um usuario */
export const findUserRequest = (userId: string, typeUser: TypesUser) => action(UserTypes.FIND_USER_REQUEST, { userId, typeUser })

export const findUserSuccess = (response: IAxiosResponse<any>) => action(UserTypes.FIND_USER_SUCCESS, response)

export const findUserFailure = () => action(UserTypes.FIND_USER_FAILURE)

/* Actions para atualizar um usuario existente*/
export const updateUserRequest = (user: any, avatar?: any) => action(UserTypes.UPDATE_USER_REQUEST, { user, avatar })

export const updateUserSuccess = (response: IAxiosResponse<any>) => action(UserTypes.UPDATE_USER_SUCCESS, response)

export const updateUserFailure = () => action(UserTypes.UPDATE_USER_FAILURE)

/* Actions para remove um usuario existente*/
export const removeUserRequest = (user: any) => action(UserTypes.REMOVE_USER_REQUEST, { user })

export const removeUserSuccess = (userId: string) => action(UserTypes.REMOVE_USER_SUCCESS, userId)

export const removeUserFailure = () => action(UserTypes.REMOVE_USER_FAILURE)

/* Actions para determinar o usuario logado */
export const getUserLoggedRequest = () => action(UserTypes.GET_USER_LOGGED_REQUEST)

export const getUserLoggedSuccess = (userLogged: any) => action(
    UserTypes.GET_USER_LOGGED_SUCCESS,
    { userLogged }
)
export const getUserLoggedFailure = () => action(UserTypes.GET_USER_LOGGED_FAILURE)

/* Actions para deslogar o usuario logado */
export const removeUserLoggedRequest = (id?: string) => action(UserTypes.REMOVE_USER_LOGGED_REQUEST, { id })

export const removeUserLoggedSuccess = (id?: string) => action(UserTypes.REMOVE_USER_LOGGED_SUCCESS, { id })

export const removeUserLoggedFailure = () => action(UserTypes.REMOVE_USER_LOGGED_FAILURE)

/*Actions para avatar */
export const changeAvatarFile = (avatar?: File) => action(UserTypes.CHANGE_AVATAR_FILE, { avatar })

export const changeAvatarImg = (avatar?: any) => action(UserTypes.CHANGE_AVATAR_IMG, { avatar })

export const loadAvatarRequest = (userId: string) => action(UserTypes.LOAD_AVATAR_REQUEST, { userId })

export const loadAvatarSuccess = (avatar: any) => [
    changeAvatarImg(avatar),
    action(UserTypes.LOAD_AVATAR_SUCCESS)
]

export const loadAvatarFailure = () => action(UserTypes.LOAD_AVATAR_FAILURE)

export const removeAvatarRequest = (userId: string) => action(UserTypes.REMOVE_AVATAR_REQUEST, { userId })

export const removeAvatarSuccess = () => action(UserTypes.REMOVE_AVATAR_SUCCESS)

export const removeAvatarFailure = () => action(UserTypes.REMOVE_AVATAR_FAILURE)
